<template>
  <div class="wx-h5">
    <van-loading
      color="#1989fa"
      vertical
      text-size="26"
      size="26"
      v-if="!visible"
      >页面加载中...</van-loading
    >
    <div class="shadow" v-if="visible">
      <wx-open-launch-weapp
        id="launch-btn"
        appid="wx19725ce9a1332a05"
        path="pages/index/index?jumptype=h5"
      >
        <script type="text/wxtag-template">
                <style>.shadow__con{display:flex;flex-direction:column;justify-content:center;align-items:center;padding:30px;box-sizing:border-box;border-radius:12px}.shadow__con span{font-size:24px;margin-bottom:10px}.shadow__con  button{outline:transparent;border-color:transparent;width:100%;height:60px;line-height:60px;font-size:24px;border-radius:30px;background:'#14a480';text-align:center;border-radius:30px;color:'#fff'}
                </style>
                <!-- <button class="btn">App内查看</button> -->
                <div class="shadow__con">
                    <span>支付成功</span>
                    <button class="integral__btn">回到小程序</button>
                </div>
        </script>
      </wx-open-launch-weapp>
    </div>
  </div>
</template>
<script>
import config from '@/config'
import { setToken, getJumpTag, setJumpTag } from '@/utils/common'
import { fetchLogin, fetchWxGetJsSdkSignature } from '@/services/login'
import { Toast } from 'vant'
export default {
  name: 'Login',
  data () {
    return {
      params: {},
      visible: false,
    }
  },
  created () {
  },
  mounted () {
    this.params = this.getUrlCode()
    const jumpTag = getJumpTag()
    console.log(
      !this.params.code,
      '===!this.params.code',
      jumpTag && this.params.code
    )
    if (!jumpTag || (jumpTag && this.params.code)) {
      this.jumpLogin()
    } else {
      this.getWxJumpPageInfo()
    }
    // this.getWxLogin()
  },
  methods: {
    init (data) {
      const { appId, timestamp, nonceStr, signature } = data

      // eslint-disable-next-line no-undef
      wx.config({
        // debug: true,
        appId,
        timestamp,
        nonceStr,
        signature,
        jsApiList: ['chooseImage', 'previewImage'], // 必写，否则不显示
        openTagList: ['wx-open-launch-weapp'], // 必写，否则不显示
      })
      // eslint-disable-next-line no-undef
      wx.ready((config) => {
        this.visible = true
        console.log(config, 'config11')
      })
      // eslint-disable-next-line no-undef
      wx.error((res) => {
        // this.visible = true
        console.log(res, 'error')
      })
      // this.visible = true
    },

    async jumpLogin () {
      var code = this.getUrlCode().code

      if (code) {
        this.getWxPublicGetUserOpenId()
      } else {
        // eslint-disable-next-line camelcase
        const redirect_uri = location.href // 回调的页面地址
        const appId = config.appid // 公众号的appid
        const newRedirect = encodeURIComponent(redirect_uri)
        console.log(redirect_uri, '==redirect_uri')

        location.href =
          'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
          appId +
          '&redirect_uri=' +
          newRedirect +
          '&response_type=code&scope=snsapi_userinfo#wechat_redirect'
      }
    },

    async getWxPublicGetUserOpenId () {
      const { data = {} } = await fetchLogin({ code: this.params.code })
      setToken(data.h5Token)
      // const { page = '' } = this.params
      setJumpTag(true)
      console.log(document.location.hostname, 'document.location.hostname')
      location.href = location.href.split('?')[0]
    },

    async getWxJumpPageInfo () {
      // eslint-disable-next-line camelcase
      const redirect_uri = location.href // 回调的页面地址
      // const newRedirect = encodeURIComponent(redirect_uri)
      const { data = {} } = await fetchWxGetJsSdkSignature({})
      if (data && data.signature) {
        return this.init(data)
      } else {
        return Toast({ message: '跳转小程序失败' })
      }
    },

    // 获取url中的code方法
    getUrlCode () {
      // 截取url中的code方法
      const url = location.search
      // eslint-disable-next-line no-new-object
      const theRequest = new Object()
      if (url.indexOf('?') != -1) {
        const str = url.substr(1)
        const strs = str.split('&')
        for (let i = 0; i < strs.length; i++) {
          theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1]
        }
      }
      return theRequest
    },
  },
}
</script>

<style lang="scss">
.shadow {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;

  .shadow__con {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    padding: 30px;
    box-sizing: border-box;
    border-radius: 12px;
    .shadow__con > span {
      font-size: 32px;
      margin-bottom: 10px;
    }
    .shadow__con > button {
      outline: transparent;
      border-color: transparent;
      width: 100%;
      height: 100px;
      line-height: 100px;
      font-size: 35px;
      background: #14a480;
      text-align: center;
      border-radius: 60px;
      color: #fff;
    }
  }
}
.wx-h5 {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
}
</style>
